import React from "react";
import "./src/css/fonts.css";
import "./src/css/global.css";
import "./src/css/style.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider, createTheme } from "@mui/material/styles";
import TopicPreviewTemplateWithApollo from "./src/templates/TopicPreviewTemplateWithApollo";
import ManualPreviewTemplateWithApollo from "./src/templates/ManualPreviewTemplateWithApollo";
import ImportExportShell from "./src/pages/importexport-shell";
// import GlobalContextProvider from "./src/GlobalContext";

const theme = createTheme({
  // palette, typography, etc. — optional overrides
});
export const wrapRootElement = ({ element }) => (
  <HelmetProvider>
    <ThemeProvider theme={theme}>{element}</ThemeProvider>
  </HelmetProvider>
);

// Implement the client-only routing here
export const wrapPageElement = ({ element, props }) => {
  // Check if the path starts with /previews
  const isPreviewRoute = props.location.pathname.startsWith("/previews");
  const isImportExportRoute = props.location.pathname.startsWith(
    "/importexport"
  );

  if (isImportExportRoute) {
    return <ImportExportShell />;
  }

  if (isPreviewRoute) {
    return (
      <Router>
        <Routes>
          <Route
            path="/previews/topic/:topicId/site/:siteId"
            element={<TopicPreviewTemplateWithApollo />}
          />
          <Route
            path="/previews/articles/:topicId/site/:siteId"
            element={<TopicPreviewTemplateWithApollo />}
          />
          <Route
            path="/previews/manual/:manualId/site/:siteId"
            element={<ManualPreviewTemplateWithApollo />}
          />
          <Route
            path="/previews/manuals/:manualId/site/:siteId"
            element={<ManualPreviewTemplateWithApollo />}
          />
        </Routes>
      </Router>
    );
  }

  return element;
};

export default { wrapPageElement };
